export const VYV_BRAND = 'VYV';
